<template>
    <v-card flat >
        <v-card-title primary-title class="justify-center">
            <img :src="`${this.customBasePath}/logo.png`" style="max-width:100%;max-height:60px"/>
        </v-card-title>
        <v-card-subtitle class="text-center pb-0">
            <div class="pt-6 headline font-weight-light">{{$t('app_check_login_desc')}}</div>
            <!--<div>Unterüberschrift here</div>-->
        </v-card-subtitle>
        <!--    <v-card-title primary-title class="justify-center">-->
        <!--      <div class="pb-3 headline font-weight-medium ">{{$t('app_check_login_title')}}</div>-->
        <!--    </v-card-title>-->
        <v-card-subtitle class="text-center pb-0"><span v-html="$t('app_login_check_existing_account')"></span></v-card-subtitle>
        <v-card-text>
            <v-container>
                <v-form ref="form" v-model="valid">
                    <!-- Navigation Buttons -->
                    <v-row align="center" justify="center" class="ma-0 mt-3">
                        <v-col v-if="!disabledLogout" cols="12" md="12" align="center">
                            <v-btn large depressed block :color="theme.btnColorPrimary" dark rounded  @click="doCancel" >{{$t('app_login_continue_with_existing_account')}}</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" align="center">
                            <v-btn large depressed block color="grey lighten-1" rounded dark @click="doQRLogin" :loading="app_loading" >{{$t('app_login_continue_with_new_account')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {validationMixin} from "../../utils/validation-mixin";
import sha1 from "js-sha1";

export default {
    mixins:[settingsMixin,validationMixin,layoutMixin],
    created(){
    },
    components:{
    },
    props:{
    },
    data: () => ({
        userName:'',
        valid: true
    }),
    computed:{
        disabledLogout() {
            return this.parseBoolean(CONFIG.DISABLE_LOGOUT, false)
        },
        // registerData(){
        //     return {
        //         username:this.userName,
        //         email:this.getUuid + '@espoto.com',
        //         password:sha1(this.password+this.email),
        //         confirm_password:sha1(this.password+this.email),
        //         is_test_account:true,
        //     }
        // },
        // getUuid() {
        //     let chars = '0123456789abcdef'.split('');
        //
        //     let uuid = [], rnd = Math.random, r;
        //     uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        //     uuid[14] = '4'; // version 4
        //
        //     for (let i = 0; i < 36; i++) {
        //         if (!uuid[i]) {
        //             r = 0 | rnd()*16;
        //             uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
        //         }
        //     }
        //     return uuid.join('');
        // }
    },
    methods:{

        doCancel(){
            this.$emit('cancel');
        },

        doQRLogin() {
            this.$emit('doQRLogin');
        },

        validate () {
            this.$refs.form.validate()
        },

    }
}
</script>
